import ReceiptIcon from "@material-ui/icons/Receipt";
import TrustDocumentList from "./TrustDocumentList";

export default {
  icon: ReceiptIcon,
  list: TrustDocumentList,
};
